import { useMutation } from "@tanstack/react-query";
import { useRef } from "react";

import { CategoryRepository } from "@/repositories/category";
import { SubCategoryFormData } from "@/schemas/subcategory-form.schema.";

export const useEditSubCategory = (
  categoryId: string,
  subCategoryId: string,
) => {
  const categoriesRepository = useRef(new CategoryRepository());

  return useMutation({
    mutationFn: (data: SubCategoryFormData) =>
      categoriesRepository.current.updateSubCategory(
        categoryId,
        subCategoryId,
        data,
      ),
  });
};
